import { StrictMode } from "react";
import ReactDOM from "react-dom/client";

import "./index.css";
import Providers from "./providers";

import App from "./views/app";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <StrictMode>
    <Providers>
      <App />
    </Providers>
  </StrictMode>
);
